import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartOrderSummaryEntityParams {
  orderGroupId: number;
}
export class CartOrderSummaryEntity extends BaseEntityClass {
  orderGroupId: number;
  constructor(params: CartOrderSummaryEntityParams) {
    super();
    this.type = "cart_order_summary_event";
    this.entity_version = 2;
    this.orderGroupId = params.orderGroupId;
  }
}
